import React, { useState,useEffect} from "react";
import classes from "../style/Style.module.css";
import "../style/Infoscreens.scss";
import { useNavigate } from "react-router-dom";
import { ROUTE_NOMINEE_VERIFICATION, ROUTE_OTP_VERIFICATION } from "../Routes";
import axios from "../libs/axiosConfig";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { selectPanNumber } from "../Store/panNumberSlice";
import Toast from "../Components/ToastMsg/Toast";
import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import NewDexterLogo from "../Images/NewDexterLogo.svg";
import { selectPhoneNumber } from "../Store/MobileSlice";

const NomineenomineephoneNumber = () => {
  const [nomineephoneNumber, setnomineephoneNumber] = useState("");
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const Navigate = useNavigate();
  // const refreshToken = useSelector(selectRefreshToken);
  const [isLoading, setIsLoading] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);


  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  useEffect(() => {
    // Set the nominee phone number when component mounts
    setnomineephoneNumber(phoneNumber);
  }, [phoneNumber]);

  // const handleInputChange = (e) => {
  //   const input = e.target.value.replace(/\D/g, "");
  //   setnomineephoneNumber(input);
  // };

  // const handleClearButtonClick = () => {
  //   setnomineephoneNumber("");
  // };

  const handleSubmit = async () => {
    try {
      // setApiCallsInProgress(apiCallsInProgress + 1);
      setApiCallsInProgress(apiCallsInProgress + 1);
      const requestBody = {
        dexterrCustomerBasicQuestions: {
          mobile_no: phoneNumber,
          request_type: "get",
          country_code: "+91",
        }
      };
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };

      const secondApiResponse = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
        headers: headers
      });


      const dexterrsendOtp =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

       const token = storedToken;

      const requestData = {
        OtpVerification: {
          mobileNumber: nomineephoneNumber,
          pan: panNumber,
          service: "nominee",
          job: "sendOtp",
        },
      };
      console.log(nomineephoneNumber)
      const dexterrsendOtpresponse = await axios.post(dexterrsendOtp, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
          // RefreshToken: refreshToken

        },
      });

      // const dexterrsendOtp = "https://partnerapp.ambrela.money/api/nominee-verification";
      // const dexterrsendOtprequest = {
      //   job: "sendOtp"
      // }
      // const dexterrsendOtpresponse = await axios.post(dexterrsendOtp, dexterrsendOtprequest, {
      //   headers: {
      //     Authorization: `Bearer ${token}`,
      //     // RefreshToken: refreshToken

      //   },
      // })

      if (dexterrsendOtpresponse.status === 200) {
        console.log("Nominee Phone Number:", nomineephoneNumber);
        Navigate(ROUTE_NOMINEE_VERIFICATION, {
          state: { nomineephoneNumber: nomineephoneNumber },
        });
      } else {
        setApiCallsInProgress(apiCallsInProgress - 1);

        // Toast.error(response.data.message + " " + response.data.errorMessage);
      }
    } catch (error) {
      setApiCallsInProgress(apiCallsInProgress - 1);

      // Handle errors here
      console.error("Error occurred:", error);
      // You can display an error message to the user using a toast or any other method
      Toast.error(
        error.response.data.errorMessage +
          " " +
          error.response.data.message || "Error"
      );    }
  };

  return (
    <div className="nomineesendotp_Main_Container">
      <header className="Nomineesend_Splash1Header">
        <img alt="" src={NewDexterLogo} className="DexterLogo"/>
      </header>
      <div className="Nominee_sendotp_Input_Div_Container">
        <p className="Nominee_sendotp_Input_Heading_text">Confirm your Nominee details. </p>
        <span className="Nominee_sendotp_Input_Sub_heading">To receive a code, click on "Send OTP". </span>
        {/* <div className={classes.Input_Filed_Box}>
          <div className={classes.Input_Inner_Container}>
            <span className={classes.Enter_mobile_text}>+91 </span>
            <input
              className={classes.Input_Filed}
              value={nomineephoneNumber}
              readOnly 
              maxLength={10}
            />
           
          </div>
        </div> */}
        <button className={classes.Submit_button} onClick={handleSubmit}>
          Send OTP
        </button>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default NomineenomineephoneNumber;
